import UserModel from '../models/UserModel';

export default class UserCollection extends Backbone.Collection {
  constructor(options) {
    super(options);
    this.model = UserModel;
  }

  url() {
    return appConstants.HrApiPaths.MAKESHIFT_HR_BASE_URL + appConstants.EndPoints.GET_USER;
  }

  parse(data) {
    return data.user ? data.user : data;
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;

    switch (actionType) {
      case ActionTypes.GET_LOCATION:
        const location = UserStore.getLocationById(
          payload.postData[Utils.getEndpointParam('LOCATION_ID_PARAM')],
        );
        if (!_.isEmpty(location)) {
          UserStore.trigger('user:location:load:success', location);
        } else {
          Utils.setMakeshiftTokenHeader();

          const locURL =
            appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV +
            appConstants.ApiPaths.API_VERSION_PATH +
            appConstants.EndPoints.GET_LOCATIONS.replace('%d', payload.postData[Utils.getEndpointParam('LOCATION_ID_PARAM')]);

          UserStore.fetch({
            url: locURL,
            type: 'GET',
            success: UserStore.onLocationHandler,
            fail: UserStore.onLocationError,
          });
        }
        break;
      // Commenting out for now.
      // case ActionTypes.GET_USER:
      //   if (!Utils.isNotDefined(payload.postData[Utils.getEndpointParam('USER_ID')])) {
      //     // This endpoint is only really used for retrieving a user by id, and getting their full name
      //     Utils.setHRTokenHeader();
      //     var userURL = appConstants.HrApiPaths.MAKESHIFT_HR_BASE_URL + appConstants.EndPoints.GET_USER;
      //     userURL = userURL.replace('%d', payload.postData[Utils.getEndpointParam('USER_ID')]);
      //     UserStore.fetch({
      //       url: userURL,
      //       type: 'GET',
      //       success: UserStore.onUserHandler,
      //       fail: UserStore.onUserError,
      //     });
      //   }
      //   break;

      case ActionTypes.GET_SHARED_CALENDAR:
        Utils.setMakeshiftTokenHeader();
        var skipParam = !_.isUndefined(payload.postData[Utils.getEndpointParam('SKIP_DELIVERY')])
          ? '?skip_delivery=true'
          : '?skip_delivery=false';
        var userURL = appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.SCHEDULE_SHARES_PATH
          + skipParam;
        UserStore.fetch({
          url: userURL,
          type: 'GET',
          success: UserStore.onSharedCalendarHandler,
          error: UserStore.onSharedCalendarError,
        });
        break;

      case ActionTypes.SEND_SHARED_CALENDAR:
        Utils.setMakeshiftTokenHeader();
        var userURL = appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.SCHEDULE_SHARES_PATH;
        UserStore.fetch({
          url: userURL,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(payload.postData),
          success: UserStore.onSharedCalendarSentHandler,
          error: UserStore.onSharedCalendarSentError,
        });
        break;
      case ActionTypes.REQUEST_PASSWORD:
        Utils.setMakeshiftTokenHeader();
        var userURL = appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.PASSWORD_RESET_PATH;
        UserStore.fetch({
          url: userURL,
          type: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify(payload.postData),
          success: UserStore.onPasswordResetSuccess,
          error: UserStore.onPasswordResetError,
        });
        break;
      case ActionTypes.REMOVE_SHARED_CALENDAR:
        Utils.setMakeshiftTokenHeader();
        var userURL = `${appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_PATH
          + appConstants.EndPoints.SCHEDULE_SHARES_PATH}/${
          payload.postData[Utils.getEndpointParam('SCHEDULE_SHARE_ID_PARAM')]
        }`;
        UserStore.fetch({
          url: userURL,
          type: 'DELETE',
          contentType: 'application/json',
          data: JSON.stringify(payload.postData),
          success: UserStore.onSharedCalendarRemovedHandler,
          error: UserStore.onSharedCalendarRemovedError,
        });
        break;
    }
  }
}
